import { FC } from 'react'

const DpdIcon: FC = () => (
  <svg
    width="41"
    height="20"
    viewBox="0 0 41 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="41"
      height="20"
      rx="5"
      fill="white"
    />
    <g clipPath="url(#clip0_42964_865310)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.2687 13.7339C24.6619 13.9033 23.8717 13.9738 23.1944 13.9738C21.4305 13.9738 20.2734 13.0566 20.2734 11.3774C20.2734 9.78284 21.36 8.75275 22.9404 8.75275C23.2931 8.75275 23.6741 8.79508 23.8999 8.90797V6.59375H25.2687V13.7339ZM23.8999 10.0933C23.6883 9.99451 23.3919 9.93806 23.0533 9.93806C22.2208 9.93806 21.6704 10.4461 21.6704 11.3351C21.6704 12.2805 22.2631 12.8167 23.2367 12.8167C23.406 12.8167 23.6741 12.8167 23.8999 12.7603V10.0933ZM36.5153 13.7339C35.9085 13.9033 35.1183 13.9738 34.4268 13.9738C32.677 13.9738 31.5058 13.0566 31.5058 11.3774C31.5058 9.78284 32.5924 8.75275 34.1728 8.75275C34.5397 8.75275 34.9066 8.79508 35.1324 8.90797V6.59375H36.5153V13.7339ZM35.1324 10.0933C34.9207 9.99451 34.6385 9.93806 34.2998 9.93806C33.4531 9.93806 32.9028 10.4461 32.9028 11.3351C32.9028 12.2805 33.5096 12.8167 34.4833 12.8167C34.6526 12.8167 34.9066 12.8167 35.1324 12.7603V10.0933ZM27.4277 10.0933C27.6535 9.99451 27.978 9.96629 28.2461 9.96629C29.0928 9.96629 29.6714 10.4461 29.6714 11.3068C29.6714 12.3228 29.0223 12.7885 28.1615 12.8026V13.9738H28.232C30.01 13.9738 31.0684 13.0002 31.0684 11.2645C31.0684 9.68406 29.9395 8.75275 28.2744 8.75275C27.4277 8.75275 26.5951 8.95031 26.0448 9.17606V15.8788H27.4277V10.0933Z"
        fill="#3F3F42"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2227 5.49316L15.4484 5.74716L15.5754 5.67661L15.2227 5.49316Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8828 5.30957L15.3202 5.81757L15.4755 5.7329L15.3061 5.53535L14.8828 5.30957Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5312 5.12598L15.1945 5.88798L15.3497 5.80331L14.9687 5.35175L14.5312 5.12598Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1953 4.94238L15.0702 5.95838L15.2254 5.87372L14.6186 5.16816L14.1953 4.94238ZM15.8745 6.73448L15.7757 6.79092L15.8745 6.90381V6.73448Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8516 4.75879L14.9381 6.02879L15.0933 5.94412L14.2749 4.98457L13.8516 4.75879ZM15.813 6.76255L15.6578 6.86133L15.8694 7.11533V6.84721L15.813 6.76255Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 4.57617L14.8123 6.10017L14.9817 6.01551L13.9374 4.80195L13.5 4.57617ZM15.6872 6.83393L15.532 6.93271L15.8706 7.32782V7.05971L15.6872 6.83393Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1641 4.39258L14.7022 6.17057L14.8574 6.08591L13.5874 4.61835L13.1641 4.39258ZM15.5629 6.91844L15.4077 7.00311L15.8734 7.55344V7.28533L15.5629 6.91844Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8242 4.20898L14.574 6.24098L14.7292 6.15631L13.2476 4.43476L12.8242 4.20898ZM15.4348 6.98885L15.2795 7.07351L15.8722 7.76496V7.49685L15.4348 6.98885Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4727 4.02539L14.4482 6.31138L14.6034 6.22671L12.9101 4.25117L12.4727 4.02539ZM15.309 7.05925L15.1537 7.14392L15.8734 7.97647V7.70836L15.309 7.05925Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1328 3.8418L14.32 6.3959L14.4752 6.29712L12.5561 4.06757L12.1328 3.8418ZM15.1808 7.12966L15.0256 7.21432L15.8722 8.2021V7.93399L15.1808 7.12966Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7773 3.6582L14.1903 6.4663L14.3455 6.36753L12.2148 3.88398L11.7773 3.6582ZM15.0652 7.20006L14.8959 7.28473L15.8695 8.41362V8.14551L15.0652 7.20006Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4414 3.47461L14.0661 6.53669L14.2354 6.43793L11.8788 3.70039L11.4414 3.47461ZM14.9409 7.27047L14.7857 7.35513L15.8723 8.63924V8.35702L14.9409 7.27047Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1055 3.29199L13.9559 6.60807L14.1111 6.50929L11.5288 3.51777L11.1055 3.29199ZM14.8167 7.34185L14.6615 7.42651L15.875 8.85174V8.58363L14.8167 7.34185Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 3.09473L13.8262 6.67892L13.9814 6.58014L11.1874 3.33461L10.75 3.09473ZM14.687 7.41269L14.5318 7.49736L15.8723 9.06367V8.79558L14.687 7.41269Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4102 2.91113L13.698 6.74932L13.8532 6.66465L10.8476 3.15102L10.4102 2.91113ZM14.5588 7.4831L14.4036 7.56776L15.8711 9.2893V9.0071L14.5588 7.4831Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0742 2.74121L13.5737 6.81928L13.729 6.73462L10.4975 2.96699L10.0742 2.74121ZM14.4345 7.55306L14.2793 7.63773L15.8738 9.50038V9.23227L14.4345 7.55306Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.84766 2.68457L13.446 6.88964L13.6012 6.80498L10.1581 2.78335L10.0734 2.74101C10.0029 2.69868 9.93232 2.68457 9.84766 2.68457ZM14.3067 7.62342L14.1515 7.70809L15.873 9.71185V9.44374L14.3067 7.62342Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.84902 2.68457C9.79258 2.68457 9.73613 2.69868 9.67969 2.71279L13.3203 6.9602L13.4896 6.87553L9.89135 2.68457C9.87724 2.68457 9.86313 2.68457 9.84902 2.68457ZM14.1952 7.69398L14.04 7.77864L15.8744 9.93763V9.6554L14.1952 7.69398Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.72011 2.69922C9.69189 2.71333 9.64956 2.72744 9.63545 2.74155L9.55078 2.78388L13.2055 7.03129L13.3607 6.94663L9.72011 2.69922ZM14.0663 7.76507L13.9111 7.86385L15.8725 10.1498V9.88172L14.0663 7.76507Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5771 2.75488L9.42188 2.83955L13.0766 7.10107L13.2318 7.0164L9.5771 2.75488ZM13.9374 7.83485L13.7822 7.93362L15.8706 10.3607V10.0926L13.9374 7.83485Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4521 2.82617L9.29688 2.91084L12.9516 7.17236L13.1068 7.08769L9.4521 2.82617ZM13.8124 7.90614L13.6572 8.00491L15.8726 10.5872V10.3191L13.8124 7.90614Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.32319 2.89648L9.16797 2.98115L12.8227 7.24267L12.9779 7.158L9.32319 2.89648ZM13.6835 7.97645L13.5283 8.07523L15.8707 10.7987V10.5305L13.6835 7.97645Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.19819 2.9668L9.04297 3.05146L12.6977 7.31298L12.8529 7.22832L9.19819 2.9668ZM13.5585 8.04676L13.4033 8.14554L15.8727 11.0101V10.742L13.5585 8.04676Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.07319 3.03711L8.91797 3.12177L12.5727 7.3833L12.7279 7.29863L9.07319 3.03711ZM13.4476 8.11707L13.2924 8.21585L15.8747 11.2356V10.9675L13.4476 8.11707Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.94428 3.09473L8.78906 3.1935L12.4579 7.45503L12.6132 7.37036L8.94428 3.09473ZM13.3187 8.20291L13.1635 8.28758L15.8728 11.4485V11.1803L13.3187 8.20291Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81538 3.16504L8.66016 3.24971L12.329 7.52534L12.4842 7.44067L8.81538 3.16504ZM13.1898 8.27323L13.0346 8.35789L15.8709 11.674V11.3918L13.1898 8.27323Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.69038 3.23633L8.53516 3.32099L12.204 7.61074L12.3592 7.51196L8.69038 3.23633ZM13.0648 8.34452L12.9096 8.42918L15.8729 11.8864V11.6183L13.0648 8.34452Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.56147 3.30566L8.40625 3.39033L12.0751 7.68007L12.2303 7.5813L8.56147 3.30566ZM12.9359 8.41385L12.7807 8.49852L15.871 12.0968V11.8287L12.9359 8.41385Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43257 3.37598L8.27734 3.46064L11.9462 7.75039L12.1014 7.65161L8.43257 3.37598ZM12.807 8.48417L12.6518 8.56883L15.8691 12.3224V12.0401L12.807 8.48417Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.30757 3.44629L8.15234 3.53096L11.8212 7.8207L11.9764 7.72192L8.30757 3.44629ZM12.6961 8.55448L12.5409 8.63915L15.8711 12.5338V12.2657L12.6961 8.55448Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.18496 3.50391L8.01562 3.58857L11.7127 7.89243L11.8679 7.79365L8.18496 3.50391ZM12.5735 8.62621L12.4183 8.71087L15.8755 12.7466V12.4785L12.5735 8.62621Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.05605 3.57422L7.88672 3.65888L11.5979 7.97685C11.612 7.94863 11.6261 7.93452 11.6544 7.92041L11.739 7.86397L8.05605 3.57422ZM12.4446 8.69652L12.2894 8.78119L15.8453 12.9298C15.8594 12.8875 15.8735 12.8451 15.8735 12.8028V12.6899L12.4446 8.69652Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92715 3.64453L7.75781 3.7292L11.5537 8.14595V8.0895C11.5537 8.04717 11.5819 7.99072 11.6101 7.94839L7.92715 3.64453ZM12.3157 8.76684L12.2028 8.83739C12.1887 8.83739 12.1746 8.8515 12.1605 8.8515L15.7729 13.0707C15.8152 13.0142 15.8434 12.9578 15.8575 12.9014L12.3157 8.76684Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.80213 3.71582L7.63281 3.80049L11.5557 8.37246V8.09023L7.80213 3.71582ZM11.9226 8.78168L15.6761 13.1702C15.7184 13.142 15.7607 13.0855 15.8031 13.0432L12.1907 8.83812C12.1342 8.86635 12.0496 8.86635 11.9931 8.83812L11.9226 8.78168Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.67322 3.78613L7.50391 3.8708L15.5472 13.2405L15.6601 13.1841C15.6742 13.1699 15.6883 13.1558 15.7024 13.1417L12.0053 8.83788H11.9912L11.6666 8.64032C11.6384 8.62621 11.6243 8.59799 11.5961 8.56977C11.5679 8.52744 11.5679 8.49921 11.5538 8.47099V8.31577L7.67322 3.78613Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.54433 3.85547L7.375 3.94014L15.4183 13.3098L15.5735 13.2252L7.54433 3.85547Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41933 3.91211L7.25 3.99678L15.3074 13.3806L15.4626 13.2959L7.41933 3.91211Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29043 3.9834L7.12109 4.06807L15.1785 13.4519L15.3337 13.3672L7.29043 3.9834Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16933 4.05371L7 4.13838L15.0574 13.5222L15.2126 13.4375L7.16933 4.05371Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.02632 4.125L6.87109 4.20967L14.9285 13.6076L15.0837 13.5088L7.02632 4.125Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.89741 4.19531L6.74219 4.27998L14.7996 13.6779L14.9548 13.5791L6.89741 4.19531Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.77241 4.26562L6.61719 4.35029L14.6887 13.7482L14.8439 13.6494L6.77241 4.26562Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.6435 4.32129L6.48828 4.40595L14.5598 13.818L14.715 13.7192L6.6435 4.32129Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5146 4.39258L6.35938 4.47724L14.4309 13.8893L14.5861 13.8046L6.5146 4.39258Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.3896 4.46289L6.23438 4.54756L10.1572 9.11951L10.2842 9.20418C10.3407 9.2324 10.3971 9.30296 10.3971 9.37351V9.38763L14.3059 13.9596L14.4611 13.8749L6.3896 4.46289Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.26069 4.5332L6.10547 4.61786L9.78845 8.92173L10.2541 9.17572L6.26069 4.5332ZM10.3811 9.33094C10.3811 9.34505 10.3952 9.35916 10.3952 9.37327V9.61316L14.177 14.0299L14.3322 13.9453L10.3811 9.33094Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.13569 4.60449L5.98047 4.68916L9.42356 8.71081L9.88923 8.96481L6.13569 4.60449ZM10.3972 9.55745V9.82557L14.0661 14.1012L14.2213 14.0165L10.3972 9.55745Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.01069 4.6748L5.85547 4.75947L9.07278 8.4989L9.52434 8.7529L6.01069 4.6748ZM10.3992 9.76888V10.0511L13.9411 14.1715L14.0963 14.0869L10.3992 9.76888Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.88178 4.73047L5.72656 4.81514L8.70399 8.28645L9.15554 8.55456L5.88178 4.73047ZM10.3973 9.99388V10.262L13.8122 14.2413L13.9674 14.1566L10.3973 9.99388Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75287 4.80078L5.59766 4.88545L8.33519 8.07454L8.78674 8.34265L5.75287 4.80078ZM10.3954 10.2053V10.4734L13.6833 14.3116L13.8385 14.2269L10.3954 10.2053Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.62788 4.87207L5.47266 4.95674L7.9703 7.87772L8.42185 8.13172L5.62788 4.87207ZM10.3974 10.4177V10.6999L13.5583 14.397L13.7135 14.2982L10.3974 10.4177Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49897 4.94238L5.34375 5.02705L7.60152 7.66581L8.05306 7.91981L5.49897 4.94238ZM10.3955 10.6432V10.9113L13.4435 14.4673L13.5987 14.3685L10.3955 10.6432Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.37006 5.01367L5.21484 5.09834L7.23272 7.45488L7.69837 7.70888L5.37006 5.01367ZM10.3936 10.8556V11.1237L13.3146 14.5386L13.4698 14.4398L10.3936 10.8556Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.24506 5.08398L5.08984 5.16865L6.86783 7.24297L7.3335 7.51108L5.24506 5.08398ZM8.94215 9.65595L9.30904 10.0793V9.92406C9.30904 9.89584 9.28082 9.8535 9.25259 9.83939L8.94215 9.65595ZM10.3956 11.0671V11.3493L13.1896 14.6089L13.3448 14.5101L10.3956 11.0671Z"
        fill="#DB0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.12006 5.14062L4.96484 5.22529L6.50294 7.0315L6.96861 7.29961L5.12006 5.14062ZM8.57726 9.44448L9.31104 10.2911V10.023L9.04292 9.71259L8.57726 9.44448ZM10.3976 11.293V11.5611L13.0646 14.6797L13.2198 14.595L10.3976 11.293Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99506 5.21094L4.83984 5.2956L6.15217 6.8337L6.60372 7.0877L4.99506 5.21094ZM8.21237 9.24668L9.31304 10.5167V10.2486L8.67804 9.50068L8.21237 9.24668ZM10.3996 11.5045V11.7725L12.9396 14.75L13.0948 14.6653L10.3996 11.5045Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.86616 5.28125L4.71094 5.36592L5.78337 6.62179L6.23492 6.87579L4.86616 5.28125ZM7.85768 9.03479L9.31113 10.7281V10.46L8.30924 9.28877L7.85768 9.03479ZM10.3977 11.73V11.9981L12.8248 14.8203L12.98 14.7356L10.3977 11.73Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.73725 5.35156L4.58203 5.43623L5.41458 6.4099L5.86613 6.66388L4.73725 5.35156ZM7.48891 8.82288L9.30922 10.9395V10.6714L7.94044 9.09097L7.48891 8.82288ZM10.3958 11.9414V12.2095L12.6959 14.8906L12.8511 14.8059L10.3958 11.9414Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.61225 5.42188L4.45703 5.50654L5.04969 6.19799L5.50124 6.4661L4.61225 5.42188ZM7.12402 8.61097L9.31122 11.1651V10.8969L7.57557 8.87908L7.12402 8.61097ZM10.3978 12.1528V12.4209L12.5709 14.9609L12.7261 14.8762L10.3978 12.1528Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.48335 5.49316L4.32812 5.57783L4.6809 5.98705L5.14656 6.25516L4.48335 5.49316ZM6.75522 8.41415L9.30931 11.3775V11.1093L7.20678 8.66815L6.75522 8.41415ZM10.3959 12.3793V12.6474L12.442 15.0322L12.5972 14.9475L10.3959 12.3793Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.35683 5.5498L4.1875 5.63447L4.3145 5.78969L4.78016 6.04369L4.35683 5.5498ZM6.38882 8.20268L9.3098 11.6034V11.3212L6.85448 8.45668L6.38882 8.20268ZM10.3963 12.5912V12.8593L12.3154 15.1171L12.4707 15.0183L10.3963 12.5912Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.23159 5.62012L4.13281 5.67656L4.41503 5.83178L4.23159 5.62012ZM6.02368 7.99077L9.31155 11.8148V11.5467L6.48935 8.25888L6.02368 7.99077ZM10.3981 12.8026V13.0848L12.2043 15.1874L12.3595 15.0886L10.3981 12.8026Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66797 7.7793L9.30861 12.0267V11.7586L6.11952 8.04741L5.66797 7.7793ZM10.3951 13.0286V13.2967L12.0744 15.2581L12.2296 15.1594L10.3951 13.0286Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.30469 7.58105L9.31222 12.2518V11.9696L5.75624 7.83505L5.30469 7.58105ZM10.3988 13.2396V13.5077L11.951 15.328L12.1062 15.2292L10.3988 13.2396Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.93359 7.36914L9.30801 12.4632V12.1951L5.38515 7.62314L4.93359 7.36914ZM10.3945 13.451V13.7332L11.8198 15.3983L11.975 15.3136L10.3945 13.451Z"
        fill="#DC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.57031 7.1582L9.31161 12.6756V12.4075L5.02186 7.42631L4.57031 7.1582ZM10.3982 13.6775V13.9456L11.6964 15.4696L11.8516 15.3849L10.3982 13.6775Z"
        fill="#DB0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19922 6.94629L9.30741 12.9011V12.633L4.65077 7.2144L4.19922 6.94629ZM10.3939 13.8889V14.157L11.5793 15.5399L11.7345 15.4552L10.3939 13.8889Z"
        fill="#DA0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83594 6.75L9.31101 13.1141V12.846L4.3016 7.004L3.83594 6.75ZM10.3975 14.1019V14.3841L11.4559 15.6117L11.6111 15.5271L10.3975 14.1019Z"
        fill="#D90032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 6.73438V6.93193L9.3095 13.3242V13.0561L3.9332 6.79082L3.82031 6.73438ZM10.396 14.3261V14.4954C10.396 14.5236 10.3819 14.5519 10.3678 14.566L11.3274 15.6808L11.4826 15.5961L10.396 14.3261Z"
        fill="#D80032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 6.87598V7.1582L9.3095 13.5505V13.2824L3.82031 6.87598ZM10.3819 14.5383C10.3678 14.5947 10.3255 14.6511 10.2831 14.6653L10.269 14.6794L11.2004 15.7518L11.3556 15.6671L10.3819 14.5383Z"
        fill="#D70032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 7.10156V7.36967L9.3095 13.762V13.4939L3.82031 7.10156ZM10.2973 14.651C10.2973 14.6651 10.2973 14.6651 10.2831 14.6651L10.1421 14.7497L11.0734 15.8222L11.2286 15.7375L10.2973 14.651Z"
        fill="#D60032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 7.31348V7.58159L9.3095 13.9739V13.7058L3.82031 7.31348ZM10.1844 14.7218L10.0151 14.8205L10.9605 15.9071L11.1157 15.8083L10.1844 14.7218Z"
        fill="#D50032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 7.53906V7.80717L9.3095 14.1995V13.9314L3.82031 7.53906ZM10.0574 14.7921L9.95861 14.8486C9.93039 14.8627 9.90216 14.8627 9.87394 14.8627L10.8335 15.9775L10.9887 15.8787L10.0574 14.7921Z"
        fill="#D40032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 7.75098V8.01909L9.3095 14.4114V14.1433L3.82031 7.75098ZM9.61994 14.7924L10.7065 16.0483L10.8617 15.9495L9.91628 14.8629C9.90216 14.8629 9.87394 14.877 9.85983 14.877H9.84572C9.80339 14.877 9.77516 14.8629 9.74694 14.8488L9.61994 14.7924Z"
        fill="#D30032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 7.96289V8.24511L10.5795 16.1191L10.7347 16.0203L9.71872 14.8349L9.40827 14.6656C9.35183 14.6374 9.3095 14.5668 9.3095 14.4963V14.3552L3.82031 7.96289Z"
        fill="#D20032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 8.18848V8.45659L10.4525 16.1894L10.6077 16.1048L3.82031 8.18848Z"
        fill="#D10032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 8.40039V8.6685L10.3255 16.2602L10.4807 16.1756L3.82031 8.40039Z"
        fill="#D00032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 8.61133V8.89355L10.2126 16.33L10.3678 16.2454L3.82031 8.61133Z"
        fill="#CF0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 8.83789V9.10598L10.0856 16.4014L10.2408 16.3167L3.82031 8.83789Z"
        fill="#CE0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 9.04883V9.31694L9.9445 16.4571C9.98683 16.443 10.0292 16.4289 10.0715 16.4148L10.1138 16.3866L3.82031 9.04883Z"
        fill="#CD0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 9.26074V9.54296L9.76105 16.4574C9.78928 16.4574 9.8175 16.4574 9.84572 16.4574C9.88805 16.4574 9.93039 16.4574 9.97272 16.4433L3.82031 9.26074Z"
        fill="#CC0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 9.48633V9.75444L9.4365 16.302L9.63405 16.4148C9.67639 16.4431 9.74694 16.4572 9.80339 16.4572L3.82031 9.48633Z"
        fill="#CB0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 9.69824V9.96635L9.06961 16.0905L9.53528 16.3586L3.82031 9.69824Z"
        fill="#CA0032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 9.92383V10.1919L8.70272 15.8787L9.16839 16.1468L3.82031 9.92383Z"
        fill="#C90032"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 10.1357V10.4039L8.33583 15.6673L8.78739 15.9354L3.82031 10.1357Z"
        fill="#C80033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 10.3477V10.6158L7.96894 15.4558L8.4205 15.724L3.82031 10.3477Z"
        fill="#C70033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 10.5732V10.8414L7.58796 15.2299L8.05361 15.498L3.82031 10.5732Z"
        fill="#C60033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 10.7852V11.0533L7.22107 15.0185L7.68672 15.2866L3.82031 10.7852Z"
        fill="#C50033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 10.9971V11.2652L6.85418 14.807L7.31985 15.0751L3.82031 10.9971Z"
        fill="#C40033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 11.2227V11.4908L6.48729 14.5952L6.95296 14.8633L3.82031 11.2227Z"
        fill="#C30033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 11.4336V11.7017L6.1204 14.3828L6.58607 14.6509L3.82031 11.4336Z"
        fill="#C20033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 11.6455V11.9277L5.75352 14.1714L6.20507 14.4395L3.82031 11.6455Z"
        fill="#C10033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 11.8711V12.1392L5.37252 13.9595L5.83818 14.2276L3.82031 11.8711Z"
        fill="#C00033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 12.083V12.3511L5.00564 13.7481L5.4713 14.0021L3.82031 12.083Z"
        fill="#BF0033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 12.2949V12.5771L4.63875 13.5226L5.10441 13.7907L3.82031 12.2949Z"
        fill="#BE0033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 12.5205V12.7886L4.27186 13.3107L4.73753 13.5788L3.82031 12.5205Z"
        fill="#BD0033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.82031 12.7324V12.803C3.82031 12.9441 3.91909 13.1134 4.03198 13.184L4.37064 13.3674L3.82031 12.7324Z"
        fill="#BC0033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.90234 13.0566C3.93057 13.0849 3.94468 13.1131 3.9729 13.1272L3.90234 13.0566Z"
        fill="#BB0033"
      />
    </g>
    <defs>
      <clipPath id="clip0_42964_865310">
        <rect
          width="33.3333"
          height="14"
          fill="white"
          transform="translate(3.82031 2.68555)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default DpdIcon
